import React, { useEffect, useRef } from "react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import ArrowButton from "../../components/ArrowButton";
import starsIcon from "../../assets/images/svg/starsIcon.svg";
import homeBtnIcon from "../../assets/images/svg/homeBtnIcon.svg";
import { observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";

const FooterModal = observer(
  ({
    step,
    setStep,
    onClose,
    rangeValue,
    feedbackText,
    setRangeValue,
    setFeedbackText,
    setSubmitted,
  }) => {
    const valuesRef = useRef();
    const isStep1 = step === 1;
    const handleSliderChange = (e) => {
      setRangeValue(e.target.value);
    };

    const handleChangeFeedback = (e) => {
      setFeedbackText(e.target.value);
    };

    const handleSubmit = (e) => {
      if (Number(rangeValue) !== 0 && feedbackText.length >= 5) {
        AuthStore.updateLoadingForFeedback(true);
        UserStore._postFeedback(
          {
            rating: rangeValue,
            feedback: feedbackText,
          },
          {
            onFail: (error) => {
              AuthStore.updateLoadingForFeedback(false);
            },
            onSuccess: (data) => {
              setStep(1);
              AuthStore.updateLoadingForFeedback(false);
              setSubmitted(true);
            },
          }
        );
      }
    };

    const getRateText = () =>
      Number(rangeValue) ? `${rangeValue} out of 10` : "Slide to rate";

    const setValuesToDefault = () => {
      setFeedbackText("");
      setRangeValue(0);
    };
    valuesRef.current = setValuesToDefault;

    useEffect(() => {
      valuesRef.current();
    }, [isStep1]);

    const rangeInputRef = useRef();

    //to prevent mouse wheel scroll in input type 'range'
    function createScrollEventHandler(milliseconds) {
      let allowed = true;
      return (event) => {
        event.preventDefault();
        if (allowed) {
          allowed = false;
          setTimeout(() => {
            allowed = true;
          }, milliseconds);
        }
      };
    }

    let scrollEventHandler = createScrollEventHandler(3000);
    useEffect(() => {
      if (rangeInputRef.current) {
        rangeInputRef.current.addEventListener("wheel", scrollEventHandler);
      }
    }, [rangeInputRef, scrollEventHandler]);

    return (
      <div className="footer_modal">
        {AuthStore.isLoadingForFeedback && (
          <div className="footer_loader_container">
            <img className="loader_gif" src={loaderGIF} alt="loading..." />
          </div>
        )}
        {step === 0 && (
          <>
            <div className="help_us_improve_text_container">
              <p className="help_us_improve_text">Help us Improve</p>
            </div>
            <div className="textarea_wrapper">
              <textarea
                rows={5}
                placeholder="Type something....."
                className="feedback_textarea"
                value={feedbackText}
                onChange={handleChangeFeedback}
              />
            </div>
            <div className="slide_to_rate">
              <p className="slide_to_rate_text">{getRateText()}</p>
              <div className="slider_container">
                <div className="slider_points_wrapper">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                    <div
                      className={`slider_point ${
                        num <= rangeValue && "slider_point_blue"
                      }`}
                    ></div>
                  ))}
                </div>
                <input
                  type="range"
                  min="0"
                  max="10"
                  step="1"
                  value={String(rangeValue)}
                  onChange={handleSliderChange}
                  ref={rangeInputRef}
                  className="slide_to_rate_input"
                />
              </div>
            </div>
            <div className="bottom_navigation">
              <ArrowButton
                disabled={!(rangeValue !== "0" && feedbackText.length >= 5)}
                type={"next"}
                label={"Submit"}
                onClick={handleSubmit}
              />
            </div>
          </>
        )}
        {step === 1 && (
          <div className="feedback_success">
            <img src={starsIcon} alt="stars" />
            <p>
              Thank you for your valuable feedback. This will help us keep
              improving!
            </p>
            <div
              className="go_to_home_btn"
              onClick={() => {
                onClose();
                setSubmitted(false);
              }}
              // tabIndex={0}
            >
              <p>Back to Home</p>
              <button className="button">
                <img src={homeBtnIcon} alt="home" />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default FooterModal;
